import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import "../appointment/ordornance.css";
import Lg from '../image/LG1.png';
import api from '../../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import { FaArrowLeft } from "react-icons/fa";


import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const Docteur = () => {

  const [UserData, setUserData] = useState([]);
  const [ConsultationData, setConsultationData] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const [DoctorData, setDoctorData] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const consultationId = queryParams.get('consultationId'); // Récupère le paramètre 'consultationId'
  const patientId = queryParams.get('patientId'); // Récupère le paramètre 'patientId'

  useEffect(() => {

    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');

        // response.data.role.name.includes('Admin') ? console.log(response.data.role.name) : console.log('RAS');
        //    console.log(response.data);

        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };

    const fetchConsultationData = async () => {
      try {
        const response = await api.get(`api/consultations/${consultationId}`);

        // response.data.role.name.includes('Admin') ? console.log(response.data.role.name) : console.log('RAS');
        //    console.log(response.data);

        setConsultationData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };

    // Charge les données du patient
    const fetchPatientData = async () => {
      try {
        const response = await api.get(`/clinic/getpatient/${patientId}`);
        setPatientData(response.data);
        // console.log(response);
      } catch (error) {
        console.error('Erreur lors de la récupération des données du patient:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPatientData();
    fetchConsultationData();
    fetchLoggedUserData();

  }, []); // Exécuter cet effet une seule fois au montage

  useEffect(() => {
    // Charger les données du docteur une fois que les données de consultation sont disponibles
    const fetchDoctorData = async () => {
      if (ConsultationData?.doctorId) {
        try {
          const token = localStorage.getItem('access_token'); // ou depuis le state

          const response = await api.get(`api/users/${ConsultationData.doctorId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setDoctorData(response.data);
          console.log(response);
        } catch (error) {
          console.error('Erreur lors de la récupération des données du Docteur:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    if (ConsultationData?.doctorId) {
      fetchDoctorData();
    }
  }, [ConsultationData]); // Dépendance sur ConsultationData

  const calculateAge = (birthDate) => {
    if (!birthDate) return ""; // Vérification si la date est vide

    const birth = new Date(birthDate);
    const today = new Date();

    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();

    // Si l'anniversaire n'est pas encore passé cette année, on enlève 1 an
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  };

  // Exemple d'utilisation avec patientData
  const age = patientData?.age ? calculateAge(patientData.age) : "";


  const generatePDF = async () => {
    try {
      const content = document.querySelector('.ordonnance-container');
      const canvas = await html2canvas(content, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`ordonnance_${patientData?.name || 'patient'}.pdf`);
    } catch (error) {
      toast.error("Erreur lors de la génération du PDF");
    }
  };

  const hospital_logo = UserData?.hospital_id?.[0]?.picture || Lg;
  return (
    <div className="">
      <div className="bg-white py-1 rounded-3">
        <p className="text-center fs-5 tet pb-3">Ordonnance médicale </p>
        <div className="d-flex justify-content-end mb-3 mx-2">
          {/* <button className="btn btn toute mx-2" onClick={() => navigate(-1)}>
            <FaArrowLeft /> Retour
          </button> */}
          <button className="btn btn-success" onClick={generatePDF} style={{ color: 'white' }}>
            Générer PDF
          </button>
        </div>
        <div className="d-flex justify-content-center ">
          <div className="ordonnance-container position-relative maindiv">
            <div className="">
              <div className="d-flex justify-content-between">
                <div>
                  <img src={hospital_logo} alt="logo" className="img-fluid w-100" style={{
                    maxWidth: '100px', maxHeight: '100px'
                  }} />
                </div>
                <div className="text-end mt-2">
                  <p style={{ fontSize: '13px' }}><strong>CLINIQUE POLYVALENTE OLUWA SHEYI</strong></p>
                  <p style={{ fontSize: '13px', marginTop: '-.7rem' }}>06 B.P. 2102 COTONOU - </p>
                  <p style={{ fontSize: '13px', marginTop: '-.7rem' }}>CEL: (+229) 55 42 99 99 / 52 47 54 54</p>
                </div>
              </div>
            </div>
            <h5 className="text-center mt-3" style={{ color: '#043972', fontSize: '14px' }}>MEDICAL PRESCRIBTION</h5>
            <form className="row">
              <div className="col-6 mx-auto mb-3">
                <div className="d-flex mt-3 align-items-center">
                  <label
                    className="form-label me-2"
                    style={{ whiteSpace: 'nowrap', fontSize: '14px' }}
                  >
                    Patient's name :
                  </label>
                  <input
                    type="text"
                    value={`${patientData?.firstname} ${patientData?.lastname}`}
                    className="form-control"
                    style={{
                      border: 'none',
                      borderBottom: '1.5px solid #043972',
                      borderRadius: '0',
                      background: 'transparent',
                      marginBottom: '2rem'
                    }}
                  />
                </div>
              </div>
              <div className="col-6 mx-auto mb-3">
                <div className="d-flex mt-3 align-items-center">
                  <label
                    className="form-label me-2"
                    style={{ whiteSpace: 'nowrap', fontSize: '14px' }}
                  >
                    Date
                  </label>
                  <input
                    type="date"
                    // defaultValue={new Date().toISOString().split('T')[0]} // Définit la date du jour
                    defaultValue={ConsultationData?.createdAt ? new Date(ConsultationData?.createdAt).toISOString().split('T')[0] : ''}
                    className="form-control"
                    style={{
                      border: 'none',
                      borderBottom: '1.5px solid #043972',
                      borderRadius: '0',
                      background: 'transparent',
                      marginBottom: '2rem'
                    }}
                  />
                </div>
              </div>
              <div className="col-6 mx-auto mb-3">
                <div className="d-flex mt-3 align-items-center">
                  <label
                    className="form-label me-2"
                    style={{ whiteSpace: 'nowrap', fontSize: '14px' }}
                  >
                    Date of birth :
                  </label>
                  <input
                    type="date"
                    value={patientData?.age ? new Date(patientData?.age).toISOString().split('T')[0] : ''}
                    className="form-control"
                    style={{
                      border: 'none',
                      borderBottom: '1.5px solid #043972',
                      borderRadius: '0',
                      background: 'transparent',
                      marginBottom: '2rem'
                    }}
                  />
                </div>
              </div>
              <div className="col-3 mx-auto mb-3">
                <div className="d-flex mt-3 align-items-center">
                  <label
                    className="form-label me-2"
                    style={{ whiteSpace: 'nowrap', fontSize: '14px' }}
                  >
                    Age :
                  </label>
                  <input
                    type="age"
                    value={age + ' years Old'}
                    className="form-control"
                    style={{
                      border: 'none',
                      borderBottom: '1.5px solid #043972',
                      borderRadius: '0',
                      background: 'transparent',
                      marginBottom: '2rem'
                    }}
                  />
                </div>
              </div>
              <div className="col-3 mx-auto mb-3">
                <div className="d-flex mt-3 align-items-center">
                  <label
                    className="form-label me-2"
                    style={{ whiteSpace: 'nowrap', fontSize: '14px' }}
                  >
                    Gender :
                  </label>
                  <input
                    type="text"
                    value={patientData?.gender}
                    className="form-control"
                    style={{
                      border: 'none',
                      borderBottom: '1.5px solid #043972',
                      borderRadius: '0',
                      background: 'transparent',
                      marginBottom: '2rem'
                    }}
                  />
                </div>
              </div>
            </form>
            <div className="mt-4">
              <div className="table-responsive">
                <table className="table table-bordered" style={{ fontSize: '14px' }}>
                  <thead>
                    <tr style={{ backgroundColor: 'rgba(248, 249, 250, 0.1) !important' }}>
                      <th>N°</th>
                      <th>Médicament</th>
                      <th>Qté</th>
                      <th>Posologie</th>
                      <th>Période</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ConsultationData?.prescriptions?.map((prescription, index) => (
                      <tr key={prescription._id}>
                        <td>{index + 1} {/* Affiche l'indice + 1 pour numéroter les lignes */}</td>
                        <td>{prescription.name}</td>
                        <td>{prescription.boxes}</td>
                        <td>{prescription.dosage}</td>
                        <td>{prescription.duration}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mt-5 scurr1">
              <div className="row">
                <div className="col-8"></div>
                <div className="col-4">
                  <p className="text-center my-0">{DoctorData?.lastname + ' ' + DoctorData?.firstname}</p>
                  {/* <p className="text-center my-0">{DoctorData?.role?.name}</p> */}

                  <span className="d-block" style={{ borderBottom: '2px solid #30B697' }}></span>
                  <p className="text-center mt-2" style={{ color: '#043972' }}>Doctor's Signature</p>
                </div>
              </div>
            </div>
            <br />
            <div className="mt-4 scurr">
              <div className="px-5">
                <p className="text-center" style={{ fontSize: '14px', color: '#043972' }}>Prière de rapporter l'ordonnance à toute consultation ultérieure et prévenir 48h à l'avance pour annuler tout rendez-vous. Merci.</p>
              </div>
              <span className="d-block" style={{ borderBottom: '4px solid #14AC89' }}></span>
              <p className="text-center mt-3" style={{ fontSize: '14px', color: '#043972' }}>
                06 B.P. 2102 COTONOU - CEL: (+229) 55 42 99 99 / 52 47 54 54
              </p>
              <p className="text-center mt-3" style={{ fontSize: '14px', color: '#043972' }}>
                N° IFU 3202378655640 - RCCM RB/COT/23 B 34365 DU 26/01/2023
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Docteur;